<template>
  <div class="flex flex-cols items-center justify-center h-full bg-primary-200">
    <div class="p-8">
      <div>
        <h1 class="font-light text-[12rem] sm:text-[16rem]">
          {{ statusCode }}
        </h1>

        <h2 class="text-center font-extrabold">
          {{ statusMessage }}
        </h2>
      </div>

      <div class="flex flex-rows items-center justify-center w-full gap-2">
        <router-link :to="{ name: Pages.app }" class="mt-8 text-center btn-block btn btn-lg btn-primary">
          Go To Home
        </router-link>

        <router-link to="" class="mt-8 text-center btn-block btn btn-lg btn-secondary" @click="$router.go(-1)">
          Previous Page
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Pages } from '@/router';

interface Props {
  statusCode: string;
  statusMessage: string;
}

defineProps<Props>();

</script>
